import Reveal from "./Reveal";

export const SectionHeading = ({
  overline,
  title,
  description,
  align = "center",
  light = false,
  className = "",
}) => {
  const alignment = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  return (
    <Reveal className={`flex flex-col ${alignment} max-w-3xl ${className}`}>
      {overline && (
        <span
          className={`overline text-xs mb-4 ${light ? "text-gold-light" : "text-gold"}`}
          data-testid="section-overline"
        >
          {overline}
        </span>
      )}
      <h2
        className={`font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight ${
          light ? "text-white" : "text-navy"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p
          className={`mt-5 text-base sm:text-lg leading-relaxed ${
            light ? "text-white/75" : "text-muted-foreground"
          } ${align === "center" ? "max-w-2xl" : ""}`}
        >
          {description}
        </p>
      )}
    </Reveal>
  );
};

export default SectionHeading;
